import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { useTranslations } from "@/hooks/useTranslations";

interface PersonalInfoFormProps {
  loading: boolean;
  formData: {
    first_name: string;
    last_name: string;
    phone: string;
    email: string;
    country: string;
    city: string;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const PersonalInfoForm = ({
  loading,
  formData,
  onChange,
  onSubmit,
}: PersonalInfoFormProps) => {
  const { t } = useTranslations("settings");
  
  return (
    <form onSubmit={onSubmit} className="space-y-4 bg-white/90 dark:bg-gray-800/90 p-4 rounded-xl">
      <div className="grid gap-4 md:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="first_name" className="dark:text-gray-200">{t("profile.firstName")}</Label>
          <Input
            id="first_name"
            name="first_name"
            value={formData.first_name}
            onChange={onChange}
            className="rounded-xl"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="last_name" className="dark:text-gray-200">{t("profile.lastName")}</Label>
          <Input
            id="last_name"
            name="last_name"
            value={formData.last_name}
            onChange={onChange}
            className="rounded-xl"
          />
        </div>
      </div>
      {/* Phone field is hidden but we keep it in the formData */}
      <input
        type="hidden"
        name="phone"
        value={formData.phone}
      />
      <div className="grid gap-4 md:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="country" className="dark:text-gray-200">{t("profile.country")}</Label>
          <Input
            id="country"
            name="country"
            value={formData.country}
            onChange={onChange}
            placeholder="Portugal"
            className="rounded-xl"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="city" className="dark:text-gray-200">{t("profile.city")}</Label>
          <Input
            id="city"
            name="city"
            value={formData.city}
            onChange={onChange}
            placeholder="Lisboa"
            className="rounded-xl"
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="email" className="dark:text-gray-200">{t("profile.email")}</Label>
        <Input
          id="email"
          value={formData.email}
          disabled
          className="bg-muted rounded-xl"
        />
      </div>
      <Button type="submit" disabled={loading} className="rounded-xl">
        {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        {t("profile.saveChanges")}
      </Button>
    </form>
  );
};
